import { memo, useCallback, useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';

import styles from './index.module.css';

interface Props {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
}

const MyEditor = ({ value, onChange, onBlur }: Props) => {
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  const editorRef = useRef<any>(null);

  const handleChange = useCallback(
    (value: string) => {
      onChange(value);
    },
    [onChange],
  );

  return (
    <div className={styles.wrapper}>
      <Editor
        apiKey="ey173m3hfdhf3m03tu4itc1e5dyhs88zmfs2y51oqw12o58g"
        // No tinymceScriptSrc is set, so this loads live from TinyMCE
        // Cloud's CDN using cloudChannel to pick the major version -- not
        // from the tinymce npm package. @tinymce/tinymce-react's own
        // default channel changed from "7" to "8" as of its 6.3.0 release;
        // pinning explicitly here keeps this editor on the version that's
        // actually been tested against this plugin/toolbar list, so
        // bumping the wrapper package doesn't silently swap the live
        // editor's major version too. Revisit deliberately, with real
        // hands-on QA against the plugins below, not as a version bump.
        cloudChannel="7"
        onInit={(_evt, editor) => (editorRef.current = editor)}
        onEditorChange={handleChange}
        onBlur={onBlur}
        value={value}
        init={{
          height: 500,
          menubar: false,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'image',
            'charmap',
            'preview',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'code',
            'help',
            'wordcount',
          ],
          toolbar:
            'undo redo | blocks | ' +
            'bold italic forecolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
          content_style:
            'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        }}
      />
    </div>
  );
};

export default memo(MyEditor);
